// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import ClearwaysLogo from "../../../nextus-assets/images/clearways_logo.png";
import SoftAvatar from "components/SoftAvatar";
import { welcomeButtonStyle } from "./styles";

// Setting default values for the props of WelcomeInfoButton
function WelcomeInfoButton({ sidebarState, color = 'info', icon = null, variant = 'contained', title }) {
  
  return (
    <SoftBox display={"flex"} flexDirection={"row"} alignItems={"center"} textAlign={"center"} my={'auto'} sx={(theme) => welcomeButtonStyle(theme, { sidebarState })}>
      {icon != null && (
        <SoftBox className="icon" variant={variant} bgColor={color}>
          {icon != 'clearways' && (<Icon>{icon}</Icon>)}
          {icon == 'clearways' && (<SoftAvatar src={ClearwaysLogo} name={'clearways'} size={sidebarState == 'landing' ? 'sm' : 'xxs'} />)}
        </SoftBox>
      )}
      <SoftBox className="label">
        <SoftTypography fontWeight="medium" textTransform="capitalize">
          {title}
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props for the WelcomeInfoButton
WelcomeInfoButton.propTypes = {
  sidebarState: PropTypes.string.isRequired,
  color: PropTypes.string,
  icon: PropTypes.node,
  variant: PropTypes.string,
  title: PropTypes.node.isRequired,
};

export default WelcomeInfoButton;
